var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.carrier)?_c('span',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.carrier.logo,"height":"25px"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }